export default __webpack_public_path__ + "static/grafika_mapa-d963f441865dc5fe29e4585c0b89150e.png";